import messages from '../../messages';

const validateDateofbirth = (value, formatMessage) => {
  let fieldError = '';

  if (!value) {
    fieldError = formatMessage(messages['empty.dob.field.error']);
  } else {
    const enteredDate = new Date(value);
    const today = new Date();

    if (enteredDate > today) {
      fieldError = formatMessage(messages['dob.future.date.error']);
    }
  }

  return fieldError;
};

export default validateDateofbirth;
